import { actionTypes } from '../../constants'

export const setPrinterIPAddressAction = ip => ({ type: actionTypes.SET_PRINTER_IP_ADDRESS, payload: ip })
export const setPrinterPortAction = port => ({ type: actionTypes.SET_PRINTER_PORT, payload: port })
export const setTillNameAction = tillName => ({ type: actionTypes.SET_TILL_NAME_ACTION, payload: tillName })
export const setCardTerminalIDAction = cardTerminalID => ({ type: actionTypes.SET_CARD_TERMINAL_ID_ACTION, payload: cardTerminalID })
